export default "__VITE_ASSET__CAaqTPq4__"